export const SESSION_STORAGE_KEY = "basket_param_prefill";

export const PREFILL_APPLIED_EVENT = "basket-param-prefill:applied";
